import { dateIsEqualOrLessThanGivenDate, dateIsEqualOrGreaterThanGivenDate } from 'utils/customValidators';
import {
  unique,
  items,
  required,
  shape,
  fromModel,
  when,
  stopOnFirstFailure,
  Validator,
  concatFailure,
  Failure,
  ValidationError,
  Success,
  greaterThan
} from '@totalsoft/pure-validations';
import i18next from 'i18next';
import { isValidDateFormat } from 'utils/simple-validations';

export const mandatoryProductStateValidator = Validator(function mandatoryMainFLowValidator(content) {
  if (content.flowId && content.stateId) return Success;
  if (!content.flowId) return Failure(ValidationError(i18next.t('FinancialProduct.NullFlowIdValidation')));
  if (!content.stateId) return Failure(ValidationError(i18next.t('FinancialProduct.NullStateIdValidation')));
});
export const productStateValidator = [mandatoryProductStateValidator] |> concatFailure;

export const financialProductValidator = shape({
  productName: required,
  productCode: required,
  leasingFinancialProduct: fromModel(model =>
    shape({
      leasingTypeId: required,
      creditCurrencyId: required,
      validFrom:
        [required, dateIsEqualOrLessThanGivenDate(model.validTo) |> when(Boolean(model.validTo)), isValidDateFormat] |> stopOnFirstFailure,
      validTo:
        [dateIsEqualOrGreaterThanGivenDate(model.validFrom) |> when(Boolean(model.validFrom)), isValidDateFormat] |> stopOnFirstFailure,
      contractDuration: [required, greaterThan(0)] |> stopOnFirstFailure,
      paymentFrequency: [required, greaterThan(0)] |> stopOnFirstFailure
    })
  )
});

export const financialProductPropertiesValidator = concatFailure(
  items(
    shape({
      propertyId: required,
      propertyValue: required
    })
  ),
  unique(x => x.propertyId)
);

export const financialProductInsurerValidator = items(
  shape({
    insTypeId: required,
    insurerId: required,
    insuranceConventionId: required
  })
);

export const financialProductResidualGridValidator = concatFailure(
  items(
    shape({
      gridId: required
    })
  ),
  unique(x => x.gridId)
);
